import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PREFIX } from "src/components/Config";
const styles = {
  content: {
    minHeight: "fit-content",
    maxWidth: "508px",
    overflowY: "auto",
    borderRadius: "10px",
    padding: "28px",
    color: "#1A1919",
    margin: "auto",
    background: "#FFF",
    boxShadow: "3px 4px 9px 0px rgba(0, 0, 0, 0.25)",
    // marginBottom: "20px",
    // marginTop: "80px",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-track": {
      margin: "40px 0 40px 0",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#FD9F49",
      borderRadius: "20px !important",
    },
    "@media(max-width:600px)": {
      padding: "20px",
    },
  },
  left: {
    height: "100%",
    "@media(max-width:959px)": {
      display: "none",
    },
  },
  mainScreenBack: {
    overflow: "hidden",
    backgroundImage: `url("/images/background/superMarket.jpg")`,
    backgroundPosition: "unset",
    backgroundSize: "cover",
  },
  imageside: {
    width: "-webkit-fill-available",
    height: "100vh",
    "@media (max-width: 950px)": {
      display: "none !important",
    },
  },
  firstscreen: {
    overflowY: "auto",
    height: "inherit",
    display: "grid",
  },
  logoBox:{
    display:"flex",
    justifyContent:"center"
  }
};
const Logo = styled("img")({
  cursor: "pointer",
  width: "220px",
  padding: "20px",
});
const LoginLayout = ({ children }) => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.mainScreenBack}>
      <Grid container style={{ height: "100vh" }}>
        <Grid item xs={12} sx={{
          margin: "auto",
}}>
            <Box sx={styles.content}>
              <Box onClick={() => navigate("/")} sx={styles.logoBox}>
              <Logo src={`assets/img/${PREFIX}_logo.png`} alt=""
                onError={(e) => {
                  e.target.onerror = null; // Prevents infinite loop if the fallback image fails
                  e.target.src = "images/Logo.png"; // Set your fallback image
                }}
              />
              </Box>
              {children}
              </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

LoginLayout.propTypes = {
  children: PropTypes.node,
};

export default LoginLayout;
